<template>
  <div class="header">
    <div class="container-fluid">
      <div class="card">
        <div class="card-header">
          <h4 class="card-header-title">LDP</h4>
          <div class="card-header-action">
            <b-button class="btn-pill" variant="danger" @click="addData">
              <span class="fe fe-file-plus"></span>
              Add LDP
            </b-button>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-4 offset-6">
              <div class="form-group">
                <input
                  v-model="filters.search"
                  type="text"
                  class="form-control"
                  placeholder="Search Here..."
                  @input="onSearch" />
              </div>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-secondary" @click="clearFilters">
                <span class="fe fe-x"></span> Clear Filter
              </button>
            </div>
          </div>
        </div>

        <vue-good-table
          :columns="columns"
          :rows="ldpData"
          :sort-options="{ enabled: true }"
          style-class="vgt-table border-0 table">
          <div slot="emptystate" class="text-center font-size-14">
            {{ isLoading ? 'Loading...' : 'No data available' }}
          </div>

          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'no'">
              {{ (body.page - 1) * body.limit + props.index + 1 }}
            </span>
            <span v-else-if="props.column.field == 'provider_logo_path'">
              <img
                v-if="props.row.provider_logo_path"
                :src="getProviderLogoUrl(props.row.provider_logo_path)"
                alt="Provider Icon"
                class="provider-icon" />
              <span v-else>-</span>
            </span>
            <span v-else-if="props.column.field == 'action'">
              <b-button class="no-wrap btn-pill me-2" variant="info" size="sm" @click="viewData(props.row)">
                <span class="fe fe-eye"></span>
              </b-button>
              <b-button class="no-wrap btn-pill me-2" variant="warning" size="sm" @click="updateData(props.row)">
                <span class="fe fe-edit"></span>
              </b-button>
              <b-button class="no-wrap btn-pill" variant="danger" size="sm" @click="deleteData(props.row.id)">
                <span class="fe fe-trash"></span>
              </b-button>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] || '-' }}
            </span>
          </template>
        </vue-good-table>

        <div class="card-footer border-top">
          <div class="row align-items-center">
            <div class="col-md-4">
              <div class="d-flex align-items-center">
                <span class="text-muted small me-2">Show</span>
                <select
                  v-model="body.limit"
                  class="form-select form-select-sm"
                  style="width: 70px;"
                  @change="onPerPageChange">
                  <option v-for="option in perPageOptions" :key="option" :value="option">
                    {{ option }}
                  </option>
                </select>
                <span class="text-muted small ms-2">entries</span>
              </div>
            </div>
            <div class="col-md-4 text-center">
              <small class="text-muted">
                Showing {{ showingFrom }} to {{ showingTo }} of {{ totalItems }} entries
              </small>
            </div>
            <div class="col-md-4">
              <nav>
                <ul class="pagination pagination-sm justify-content-end mb-0">
                  <li class="page-item" :class="{ disabled: body.page === 1 }">
                    <button class="page-link" :disabled="body.page === 1" @click="changePage(body.page - 1)">
                      <i class="fe fe-chevron-left"></i>
                    </button>
                  </li>
                  <li
                    v-for="(page, index) in visiblePages"
                    :key="index"
                    class="page-item"
                    :class="{ active: body.page === page, disabled: page === '...' }">
                    <button v-if="page === '...'" class="page-link" disabled>...</button>
                    <button v-else class="page-link" @click="changePage(page)">{{ page }}</button>
                  </li>
                  <li class="page-item" :class="{ disabled: body.page === totalPages }">
                    <button class="page-link" :disabled="body.page === totalPages" @click="changePage(body.page + 1)">
                      <i class="fe fe-chevron-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <b-modal id="modal-ldp" centered hide-footer :title="modalTitle" size="lg">
        <form v-if="isAdd === true" @submit.prevent="saveAdd">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>LDP Name <span class="text-danger">*</span></label>
                <input
                  v-validate="'required'"
                  v-model="bodyAdd.name"
                  name="LDP Name"
                  type="text"
                  class="form-control"
                  placeholder="LDP Name" />
                <span class="text-sm text-danger" v-show="errors.has('LDP Name')">
                  {{ errors.first("LDP Name") }}
                </span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Address</label>
                <textarea v-model="bodyAdd.address" class="form-control" placeholder="Address" rows="2"></textarea>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Website</label>
                <input v-model="bodyAdd.website" type="text" class="form-control" placeholder="Website" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Contact Person</label>
                <input v-model="bodyAdd.contact_person" type="text" class="form-control" placeholder="Contact Person" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email</label>
                <input
                  v-validate="'email'"
                  v-model="bodyAdd.email"
                  name="Email"
                  type="email"
                  class="form-control"
                  placeholder="Email" />
                <span class="text-sm text-danger" v-show="errors.has('Email')">
                  {{ errors.first("Email") }}
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Phone</label>
                <input v-model="bodyAdd.phone" type="text" class="form-control" placeholder="Phone" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Provider Icon</label>
                <div
                  class="upload-area text-center p-4 border rounded"
                  @dragover.prevent
                  @drop.prevent="onDropProviderLogo($event, 'add')">
                  <div v-if="bodyAdd.logoPreview" class="position-relative">
                    <img :src="bodyAdd.logoPreview" alt="Provider Icon Preview" class="img-fluid rounded mb-2 provider-preview">
                    <div class="mt-2">
                      <button type="button" class="btn btn-sm btn-outline-danger me-2" @click="removeProviderLogo('add')">
                        Remove
                      </button>
                      <button type="button" class="btn btn-sm btn-danger" @click="$refs.addProviderLogoInput.click()">
                        Change
                      </button>
                    </div>
                  </div>
                  <div v-else>
                    <i class="fe fe-upload-cloud mb-2 upload-icon"></i>
                    <p class="mb-2 font-weight-bold">Drag and Drop the Image</p>
                    <p class="text-muted small mb-2">Upload file .jpeg/.jpg/.png (Max. size 500Kb)</p>
                    <p class="text-muted small mb-3">(Image recommendation 512 x 512)</p>
                    <button type="button" class="btn btn-sm btn-danger" @click="$refs.addProviderLogoInput.click()">
                      Upload
                    </button>
                  </div>
                </div>
                <input
                  ref="addProviderLogoInput"
                  type="file"
                  accept="image/jpeg,image/jpg,image/png"
                  class="d-none"
                  @change="onProviderLogoChange($event, 'add')" />
              </div>
            </div>
          </div>
          <div class="form-group text-right">
            <button type="button" class="btn btn-secondary me-2" @click="$bvModal.hide('modal-ldp')">Cancel</button>
            <button class="btn btn-danger" type="submit" :disabled="isLoading">
              <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Save
            </button>
          </div>
        </form>

        <form v-else-if="isAdd === false" @submit.prevent="saveUpdate">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>LDP Name <span class="text-danger">*</span></label>
                <input
                  v-validate="'required'"
                  v-model="bodyUpdate.name"
                  name="LDP Name"
                  type="text"
                  class="form-control"
                  placeholder="LDP Name" />
                <span class="text-sm text-danger" v-show="errors.has('LDP Name')">
                  {{ errors.first("LDP Name") }}
                </span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Address</label>
                <textarea v-model="bodyUpdate.address" class="form-control" placeholder="Address" rows="2"></textarea>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Website</label>
                <input v-model="bodyUpdate.website" type="text" class="form-control" placeholder="Website" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Contact Person</label>
                <input v-model="bodyUpdate.contact_person" type="text" class="form-control" placeholder="Contact Person" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email</label>
                <input
                  v-validate="'email'"
                  v-model="bodyUpdate.email"
                  name="Email"
                  type="email"
                  class="form-control"
                  placeholder="Email" />
                <span class="text-sm text-danger" v-show="errors.has('Email')">
                  {{ errors.first("Email") }}
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Phone</label>
                <input v-model="bodyUpdate.phone" type="text" class="form-control" placeholder="Phone" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Provider Icon</label>
                <div
                  class="upload-area text-center p-4 border rounded"
                  @dragover.prevent
                  @drop.prevent="onDropProviderLogo($event, 'update')">
                  <div v-if="bodyUpdate.logoPreview" class="position-relative">
                    <img :src="bodyUpdate.logoPreview" alt="Provider Icon Preview" class="img-fluid rounded mb-2 provider-preview">
                    <div class="mt-2">
                      <button type="button" class="btn btn-sm btn-outline-danger me-2" @click="removeProviderLogo('update')">
                        Remove
                      </button>
                      <button type="button" class="btn btn-sm btn-danger" @click="$refs.updateProviderLogoInput.click()">
                        Change
                      </button>
                    </div>
                  </div>
                  <div v-else>
                    <i class="fe fe-upload-cloud mb-2 upload-icon"></i>
                    <p class="mb-2 font-weight-bold">Drag and Drop the Image</p>
                    <p class="text-muted small mb-2">Upload file .jpeg/.jpg/.png (Max. size 500Kb)</p>
                    <p class="text-muted small mb-3">(Image recommendation 512 x 512)</p>
                    <button type="button" class="btn btn-sm btn-danger" @click="$refs.updateProviderLogoInput.click()">
                      Upload
                    </button>
                  </div>
                </div>
                <input
                  ref="updateProviderLogoInput"
                  type="file"
                  accept="image/jpeg,image/jpg,image/png"
                  class="d-none"
                  @change="onProviderLogoChange($event, 'update')" />
              </div>
            </div>
          </div>
          <div class="form-group text-right">
            <button type="button" class="btn btn-secondary me-2" @click="$bvModal.hide('modal-ldp')">Cancel</button>
            <button class="btn btn-danger" type="submit" :disabled="isLoading">
              <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Update
            </button>
          </div>
        </form>

        <div v-else>
          <div class="row">
            <div v-for="field in detailFields" :key="field.key" class="col-md-6">
              <div class="form-group">
                <label><strong>{{ field.label }}:</strong></label>
                <div v-if="field.key === 'provider_logo_path'">
                  <img
                    v-if="viewDetailData.provider_logo_path"
                    :src="getProviderLogoUrl(viewDetailData.provider_logo_path)"
                    alt="Provider Icon"
                    class="provider-preview">
                  <p v-else>-</p>
                </div>
                <p v-else>{{ viewDetailData[field.key] || '-' }}</p>
              </div>
            </div>
          </div>
          <div class="form-group text-right">
            <button type="button" class="btn btn-secondary" @click="$bvModal.hide('modal-ldp')">Close</button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
const emptyForm = () => ({
  name: '',
  address: '',
  website: '',
  contact_person: '',
  email: '',
  phone: '',
  provider_logo: null,
  provider_logo_path: '',
  logoPreview: null,
});

export default {
  name: 'Ldp',
  computed: {
    ldpData() {
      return this.$store.getters['ldp/getLdps'] || [];
    },
    totalItems() {
      return this.$store.getters['ldp/getTotalItems'] || 0;
    },
    totalPages() {
      return this.$store.getters['ldp/getTotalPages'] || 1;
    },
    isLoading() {
      return this.$store.getters['ldp/getLoading'];
    },
    showingFrom() {
      if (this.totalItems === 0) return 0;
      return (this.body.page - 1) * this.body.limit + 1;
    },
    showingTo() {
      const to = this.body.page * this.body.limit;
      return to > this.totalItems ? this.totalItems : to;
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.body.page;

      if (total <= 1) {
        pages.push(1);
      } else if (total <= 7) {
        for (let i = 1; i <= total; i += 1) pages.push(i);
      } else {
        pages.push(1);
        if (current > 3) pages.push('...');
        for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i += 1) {
          pages.push(i);
        }
        if (current < total - 2) pages.push('...');
        pages.push(total);
      }

      return pages;
    },
  },
  data() {
    return {
      body: {
        page: 1,
        limit: 10,
        search: '',
        order: 'ASC',
      },
      filters: {
        search: '',
      },
      perPageOptions: [10, 25, 50, 100],
      bodyAdd: emptyForm(),
      bodyUpdate: {
        id: '',
        ...emptyForm(),
      },
      viewDetailData: {},
      isAdd: true,
      modalTitle: 'Add LDP',
      searchTimeout: null,
      detailFields: [
        { label: 'LDP Name', key: 'name' },
        { label: 'Address', key: 'address' },
        { label: 'Website', key: 'website' },
        { label: 'Contact Person', key: 'contact_person' },
        { label: 'Email', key: 'email' },
        { label: 'Phone', key: 'phone' },
        { label: 'Provider Icon', key: 'provider_logo_path' },
      ],
      columns: [
        {
          label: 'NO',
          field: 'no',
          thClass: 'table-header text-muted font-weight-bold',
          tdClass: 'color-secondary align-middle',
          width: '5%',
          sortable: false,
        },
        {
          label: 'LDP NAME',
          field: 'name',
          thClass: 'table-header text-muted font-weight-bold',
          tdClass: 'color-secondary align-middle',
          width: '25%',
        },
        {
          label: 'WEBSITE',
          field: 'website',
          thClass: 'table-header text-muted font-weight-bold',
          tdClass: 'color-secondary align-middle',
          width: '20%',
        },
        {
          label: 'CONTACT PERSON',
          field: 'contact_person',
          thClass: 'table-header text-muted font-weight-bold',
          tdClass: 'color-secondary align-middle',
          width: '20%',
        },
        {
          label: 'PHONE',
          field: 'phone',
          thClass: 'table-header text-muted font-weight-bold',
          tdClass: 'color-secondary align-middle',
          width: '12%',
        },
        {
          label: 'ICON',
          field: 'provider_logo_path',
          thClass: 'table-header text-muted font-weight-bold',
          tdClass: 'color-secondary align-middle',
          width: '8%',
          sortable: false,
        },
        {
          label: 'ACTION',
          field: 'action',
          thClass: 'table-header no-wrap text-muted font-weight-bold',
          tdClass: 'no-wrap color-secondary align-middle',
          width: '15%',
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.getLdps();
  },
  methods: {
    onSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.body.search = this.filters.search;
        this.body.page = 1;
        this.getLdps();
      }, 500);
    },
    clearFilters() {
      this.filters.search = '';
      this.body.search = '';
      this.body.page = 1;
      this.getLdps();
    },
    addData() {
      this.isAdd = true;
      this.modalTitle = 'Add LDP';
      this.bodyAdd = emptyForm();
      this.$validator.reset();
      this.$bvModal.show('modal-ldp');
    },
    viewData(data) {
      this.isAdd = null;
      this.modalTitle = 'View LDP';
      this.$store.dispatch('ldp/getLdpById', data.id)
        .then((response) => {
          this.viewDetailData = response.data;
          this.$bvModal.show('modal-ldp');
        })
        .catch(() => {
          this.viewDetailData = { ...data };
          this.$bvModal.show('modal-ldp');
        });
    },
    updateData(data) {
      this.isAdd = false;
      this.modalTitle = 'Edit LDP';
      this.bodyUpdate = {
        id: data.id,
        name: data.name || '',
        address: data.address || '',
        website: data.website || '',
        contact_person: data.contact_person || '',
        email: data.email || '',
        phone: data.phone || '',
        provider_logo: null,
        provider_logo_path: data.provider_logo_path || '',
        logoPreview: data.provider_logo_path ? this.getProviderLogoUrl(data.provider_logo_path) : null,
      };
      this.$validator.reset();
      this.$bvModal.show('modal-ldp');
    },
    payloadFromForm(form) {
      const formData = new FormData();
      formData.append('name', form.name || '');
      formData.append('address', form.address || '');
      formData.append('website', form.website || '');
      formData.append('contact_person', form.contact_person || '');
      formData.append('email', form.email || '');
      formData.append('phone', form.phone || '');
      formData.append('isexternal', true);
      if (form.provider_logo) {
        formData.append('provider_logo', form.provider_logo);
      }
      return formData;
    },
    getProviderLogoUrl(path) {
      if (!path) return '';
      if (/^https?:\/\//.test(path)) return path;
      return `${process.env.VUE_APP_API_URL_UGEMS_UNIV}/attachments/${path}`;
    },
    onProviderLogoChange(event, mode) {
      const file = event.target.files[0];
      if (!file) return;
      this.validateAndSetProviderLogo(file, mode);
    },
    onDropProviderLogo(event, mode) {
      const file = event.dataTransfer.files[0];
      if (!file) return;
      this.validateAndSetProviderLogo(file, mode);
    },
    validateAndSetProviderLogo(file, mode) {
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        this.$swal('Error', 'Unggah file gambar yang valid (.jpeg/.jpg/.png)', 'error');
        return;
      }

      if (file.size > 500 * 1024) {
        this.$swal('Error', 'Ukuran gambar harus kurang dari 500KB', 'error');
        return;
      }

      const target = mode === 'add' ? this.bodyAdd : this.bodyUpdate;
      target.provider_logo = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        target.logoPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeProviderLogo(mode) {
      const target = mode === 'add' ? this.bodyAdd : this.bodyUpdate;
      target.provider_logo = null;
      target.logoPreview = null;
      if (mode === 'add' && this.$refs.addProviderLogoInput) {
        this.$refs.addProviderLogoInput.value = '';
      }
      if (mode === 'update' && this.$refs.updateProviderLogoInput) {
        this.$refs.updateProviderLogoInput.value = '';
      }
    },
    getErrorMessage(error, fallback) {
      const errorData = error.response && error.response.data;
      return errorData?.error || errorData?.message || errorData?.httpMessage || fallback;
    },
    saveAdd() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return;

        try {
          await this.$store.dispatch('ldp/createLdp', this.payloadFromForm(this.bodyAdd));
          this.$swal('Success', 'LDP berhasil ditambahkan', 'success').then(() => {
            this.getLdps();
            this.$bvModal.hide('modal-ldp');
          });
        } catch (error) {
          this.$swal('Error', this.getErrorMessage(error, 'Gagal menambah LDP'), 'error');
        }
      });
    },
    saveUpdate() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return;

        try {
          await this.$store.dispatch('ldp/updateLdp', {
            id: this.bodyUpdate.id,
            data: this.payloadFromForm(this.bodyUpdate),
          });
          this.$swal('Success', 'LDP berhasil diperbarui', 'success').then(() => {
            this.getLdps();
            this.$bvModal.hide('modal-ldp');
          });
        } catch (error) {
          this.$swal('Error', this.getErrorMessage(error, 'Gagal memperbarui LDP'), 'error');
        }
      });
    },
    deleteData(id) {
      this.$swal({
        title: 'Apakah Anda yakin?',
        text: "Tindakan ini tidak dapat dibatalkan!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Ya, hapus',
        cancelButtonText: 'Batal',
      }).then(async (result) => {
        if (!result.isConfirmed) return;

        try {
          await this.$store.dispatch('ldp/deleteLdp', id);
          this.getLdps();
          this.$swal('Terhapus', 'LDP telah dihapus', 'success');
        } catch (error) {
          this.$swal('Error', this.getErrorMessage(error, 'Gagal menghapus LDP'), 'error');
        }
      });
    },
    getLdps() {
      this.$store.dispatch('ldp/getLdps', { ...this.body });
    },
    onPerPageChange() {
      this.body.page = 1;
      this.getLdps();
    },
    changePage(page) {
      if (page === '...' || page < 1 || page > this.totalPages) return;
      this.body.page = page;
      this.getLdps();
    },
  },
};
</script>

<style scoped>
.me-2 {
  margin-right: 0.5rem;
}

.ms-2 {
  margin-left: 0.5rem;
}

.pagination .page-link {
  color: #2c7be5;
  border: 1px solid #dee2e6;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  min-width: 36px;
  text-align: center;
}

.pagination .page-item.active .page-link {
  background-color: #e63757;
  border-color: #e63757;
  color: white;
}

.pagination .page-item.disabled .page-link {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: transparent;
}

.pagination .page-link:hover:not(.disabled) {
  background-color: #f8f9fa;
}

.provider-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.provider-preview {
  max-height: 150px;
  object-fit: contain;
}

.upload-icon {
  font-size: 2rem;
  color: #6c757d;
}
</style>
